import useCustomNavigate from "../../hooks/useCustomNavigate";
import { useLocation } from "react-router-dom";
import useBrowserStorage from "../../hooks/useBrowserStorage";
import { useEffect } from "react";
import PersonalAccount from "../../store/PersonalAccount";
import ROUTES from "../../utils/routes.js";
import Game from "../../store/Game";
import useCurrentGame from "../../hooks/useCurrentGame";

export default function useController() {
  const { navigateTo } = useCustomNavigate();
  const location = useLocation();
  const { getItem, setItem } = useBrowserStorage();
  const { getCurrentGame } = useCurrentGame();

  const navigateByRules = () => {
    const isMeetPageVisited = getItem("isMeetPageVisited");
    const game = getCurrentGame();
    const matches = Game.countPartnerGameMatches(game.id);

    if (matches) {
      navigateTo(ROUTES.MATCHES_PAGE);
    } else {
      if (!PersonalAccount.user.gameIdsByMeets.some((id) => id === game.id)) {
        navigateTo(ROUTES.MEET_PAGE, {
          state: { from: location.pathname },
        });
        return;
      }
      navigateTo(ROUTES.IN_GAME_PAGE);
    }
  };
  const navigateToAppPage = () => {
    navigateTo(ROUTES.APP_PAGE);
    setTimeout(() => {
      window.location.reload();
    }, 100);
  };
  useEffect(() => {
    const game = getCurrentGame();
    PersonalAccount.addGameIdsByGreetings(+game.id);
  }, []);
  return {
    navigateByRules,
    navigateToAppPage,
    navigateNext: () => navigateTo(ROUTES.MEET_PAGE),
  };
}
